import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import NoticeCard from "./NoticeCard";
import log from "../image/Animation.mp4";
import { FileText, Upload, MessageCircle } from "lucide-react";

const Notification = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <main className="content-area" > <SubHeader />
          <div style={{ flex: 1, display: "flex", gap: "20px", overflow: "hidden", }} >
            <div style={{ minWidth: "300px", overflowY: "auto", paddingRight: "10px", }} > <NoticeCard /> </div>
            <div style={{ flex: 1, minWidth: "280px", display: "flex", justifyContent: "center", overflow: "hidden" }} >
              <div style={{
                width: "100%", maxWidth: "900px", height: "auto", background: "#ffffff", borderRadius: "16px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)", padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
              }}>
             <p style={{  fontSize: "12px", textAlign: "center", marginBottom: "12px", color: "#2563eb",   // nice blue maxWidth: "500px", lineHeight: "1.4", background: "#eff6ff",   // light blue backgroundpadding: "8px 12px", borderRadius: "8px"
}}>
  <strong>Document:</strong> Once the document is sent by the member it is seen in the panel under its relevant subject.
  <br />
  <strong>Message:</strong> After documents are received under the relevant tabs, admin can reply back in a message format to the particular member.
</p>
                <video src={log} autoPlay loop muted style={{ width: "100%", height: "auto", borderRadius: "12px", objectFit: "cover", }} />
                <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "30px", }} >
                  <div style={{ display: "flex", gap: "15px" }}>
                    <div style={{
                      width: "120px", padding: "15px", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column",
                      alignItems: "center", cursor: "pointer", background: "rgb(210, 211, 212)", transition: "0.3s"
                    }} >
                      <Upload size={28} color="#2563eb" />
                      <span style={{ marginTop: "8px", fontSize: "14px", fontWeight: "600" , color: "#007BFF" }}> Documemt </span>
                    </div>
                    <div style={{
                      width: "120px", padding: "15px", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column",
                      alignItems: "center", cursor: "pointer", background: "rgb(210, 211, 212)", transition: "0.3s"
                    }} >
                      <MessageCircle size={28} color="#16a34a" />
                      <span style={{ marginTop: "8px", fontSize: "14px", fontWeight: "600", color: "#007BFF" }}>
                        Message
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Notification;